import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { NavLink } from "react-router-dom";
function StMaryMessage() {
    return (
        <>
            <Header />
            {/* Inner Slider */}
            <section class="inr-header">
                <div class="container">
                    <div class="inr-header-content">
                        <h1 class="title">St. Mary’s</h1>
                        <ul class="breadcrumb">
                            <li><NavLink to="/">Home</NavLink></li>
                            <li> St. Mary’s</li>
                        </ul>
                    </div>
                </div>
            </section>
            {/*  Inner Body */}
            <section className="innerBody">
                <div className="container them-container">
                    <div className="row">
                        <div className="col-12">
                            <h1>St. Mary’s</h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 PrincipalDesk principal-message">
                            <img src="https://webapi.entab.info/api/image/SMNSB/public/images/StMary.jpg" alt="Principal Photo" className="img-fluid" />
                            <p>St. Mary, the Blessed Mother of our Lord, is the guiding light and Patron Saint of St. Mary’s Nursery School, Bokaro.
                                Her life of humility, compassion, and unwavering faith inspires our vision of nurturing young hearts with love and moral strength.
                                Under her gentle care, we uphold our school motto — “Love One Another” — fostering in every child the spirit of kindness, respect, and unity.
                                <br />
                                <i> “My soul magnifies the Lord, and my spirit rejoices in God my Saviour.”
                                    — Luke 1:46–47</i>
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <div className="clr100"></div>
            {/* Footer */}
            <Footer />
        </>
    )
}

export default StMaryMessage